<template>
  <div v-rect-loading="loading" class="notification-list">
    <TableList
      class="job-template-list"
      :actionBtn="actionBtn"
      :listData="companyTemplateList"
      :table-columns="tableColumns"
    >
      <template #filter>
        <el-select
          v-model="searchTemplateType"
          clearable
          class="el-select keywords-filter"
          :placeholder="$t(`${i18nPrefix}.label.searchTemplateType`)"
          @change="formatSearchData"
        >
          <el-option
            v-for="item in templateTypeOptions"
            :key="item.index"
            :label="item.templateTypeName"
            :value="item.template_type_name"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="searchTemplateName"
          clearable
          class="el-input keywords-filter"
          :placeholder="$t(`${i18nPrefix}.label.searchTemplateName`)"
          @input="handleKeywordsChange"
        ></el-input>
      </template>
      <template #btn>
        <el-dropdown @command="handleCommand" trigger="click">
          <el-button class="add-btn">{{ $t('common.btn.add') }}</el-button>
          <template #dropdown>
            <el-dropdown-menu class="template-type-list-dropdown">
              <el-dropdown-item v-for="(item, index) in templateDropdown" :key="index" :command="item.id">{{ item.templateTypeName }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </TableList>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import _ from 'lodash'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.notification',
      searchTemplateName: null,
      searchTemplateType: null,
      templateTypeOptions: [],
      templateDropdown: [],
      templateType: [],
      companyTemplateList: []
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.templateType`),
          dataKey: 'templateTypeName',
          width: '100'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateName`),
          dataKey: 'template_name',
          width: '200'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          dataKey: 'companyI18nName'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: (rowData) => !rowData.disabled,
          onclick: this.handleEdit
        },
        view: {
          show: true,
          onclick: this.handleView,
          labelI18nKey: 'common.btn.view'
        }
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('notificationTemplate', ['searchTemplate', 'deleteTemplate', 'searchSystemTemplate']),
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/notification-management/notification/edit/${row.id}/`,
        query: this.$route.query
      })
    },
    handleView (row) {
      this.$router.push({
        path: `/v-admin/notification-management/notification/view/${row.id}/`,
        query: this.$route.query
      })
    },
    async initData () {
      this.loading = true
      try {
        await Promise.all([
          this.handleSearchTemplate(),
          this.initTemplateDropdown()
        ])
      } finally {
        this.loading = false
      }
    },
    async initTemplateDropdown () {
      const resp = await this.searchSystemTemplate()
      if (resp) {
        const tmpTemplateDropdown = []
        const tmpTemplateTypeOptions = []
        _.forEach(resp, (data) => {
          const canDuplicate = data.can_duplicate
          let existTemplate = false
          if (!canDuplicate) {
            _.forEach(this.companyTemplateList, item => {
              if (item.company_id && item.template_type_id === data.template_type_id) {
                existTemplate = true
              }
            })
          }
          addI18nProperty(data, 'templateTypeName', 'template_type_name_cn', 'template_type_name_en')
          tmpTemplateTypeOptions.push(data)
          if (!existTemplate) {
            tmpTemplateDropdown.push(data)
          }
        })
        this.templateDropdown = tmpTemplateDropdown
        this.templateTypeOptions = tmpTemplateTypeOptions
      }
    },
    handleCommand (command) {
      this.$router.push({
        path: `/v-admin/notification-management/notification/add/${command}`,
        query: this.$route.query
      })
    },
    async handleSearchTemplate () {
      this.parseQuery()
      const params = {
        search_template_name: this.searchTemplateName,
        search_template_type: this.searchTemplateType
      }
      if (!this.loading) {
        this.$eventBus.$emit('showLoading', true)
      }
      try {
        const resp = await this.searchTemplate(params)
        if (resp) {
          this.companyTemplateList = _.map(resp, (row) => {
            addI18nProperty(row, 'templateTypeName', 'template_type_name_cn', 'template_type_name_en')
            addI18nProperty(row, 'companyI18nName', 'company_cn_name', 'company_en_name')
            return row
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.formatSearchData, 1000)
      }
      this.keywordsSearchDebounce()
    },
    formatSearchData () {
      this.$router.push({
        query: {
          ...this.$route.query,
          type: this.searchTemplateType,
          name: this.searchTemplateName
        }
      })
    },
    parseQuery () {
      this.searchTemplateName = this.$route.query.name
      this.searchTemplateType = this.$route.query.type
    }
  },
  watch: {
    $route: {
      handler () {
        this.handleSearchTemplate()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-list {
  .job-template-list {
    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .keywords-filter {
      width: 190px;
    }
  }
}

.template-type-list-dropdown {
  overflow: auto;
  max-height: 600px;
}
</style>
